import { previewCurrency, returnProtectionProductPrice } from '../constants'
import { returnProtectionProductSku } from './constants'

export const getReturnProtectionLineItem = ({ title, image }) => {
  return {
    id: 'returnProtection',
    sku: returnProtectionProductSku,
    price: returnProtectionProductPrice,
    price_currency: previewCurrency,
    quantity: 1,
    product: { name: title, image_url: image },
  }
}
